import React from "react";
import {TextField} from "@mui/material";
import {forms, objects, strings} from "@atttomyx/shared-utils";

const LabeledAddressForm = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.label)
            && (strings.isNotBlank(modified.line1)
                || strings.isNotBlank(modified.line2)
                || strings.isNotBlank(modified.locality)
                || strings.isNotBlank(modified.region)
                || strings.isNotBlank(modified.postalCode)
                || strings.isNotBlank(modified.country))

        onSync(modified);
    }

    return <div className="labeled-address-form">
        <div className="field">
            <TextField
                label="Label"
                type="text"
                value={forms.sanitizeValue(data.label)}
                onChange={(event) => onChange("label", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Line 1"
                value={forms.sanitizeValue(data.line1)}
                onChange={(event) => onChange("line1", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Line 2"
                value={forms.sanitizeValue(data.line2)}
                onChange={(event) => onChange("line2", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="City"
                value={forms.sanitizeValue(data.locality)}
                onChange={(event) => onChange("locality", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="State"
                value={forms.sanitizeValue(data.region)}
                onChange={(event) => onChange("region", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Postal Code"
                value={forms.sanitizeValue(data.postalCode)}
                onChange={(event) => onChange("postalCode", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Country"
                value={forms.sanitizeValue(data.country)}
                onChange={(event) => onChange("country", event.target.value)}
            />
        </div>
    </div>

};

export default LabeledAddressForm;
